import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { SortableHandle } from 'react-sortable-hoc';

import { SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox';
import { DeleteButton } from '../builder/ConfirmButton';
import DisabledArea from '../builder/DisabledArea';
import Input from '../builder/Input';
import MatrixSelector from '../builder/MatrixSelector';
import MediaUploader from '../builder/MediaUploader';
import Model from '../builder/Model';
import Range from '../builder/Range';
import RichEditor from '../builder/RichEditor';
import Select from '../builder/Select';
import TextArea from '../builder/TextArea';
import ToggleButton from '../builder/ToggleButton';

import mousekey from '../../hoc/keymouse';
import Tooltip from '../builder/Tooltip.js';
const SquaredButtonWithHoverActivation = mousekey(SquaredButton);

const DragHandle = SortableHandle(() => <span class="sorter_target"></span>);

const AnswerOptions = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const a = props.answer;
	const open = props?.open ?? false;

	let correct_values = null;
	if(props.answer.config?.correct_values != undefined) {
		correct_values = props.answer.config.correct_values;
		if(Array.isArray(props.answer.config.correct_values)) correct_values = props.answer.config.correct_values.join("\n");
	}

	const config_values = (Array.isArray(a.config.values)) ? a.config.values.join("\n") : a.config.values;

	const keyMouse = (e, answer) => {
		const num = parseInt(e.key);

		if(isNaN(num)) return;

		const p = [];
		for(let i = 0; i < num; i++) p.push("");
		props.actions.copy(answer, p);
	};

	const mousePaste = (type, text, answer) => {
		if(type != 'text') return;

		const p = text.split("\n");
		props.actions.copy(answer, p);
	};

	if(a.config.star_count != undefined) a.config.star_count = parseInt(a.config.star_count);
	if(a.config.default_rate != undefined) a.config.default_rate = parseInt(a.config.default_rate);

	const question = props.question;
	const actions = props.actions;
	const label = `${i18n("Answer ID")}: #${a.id}`;
	const video_url = a?.video?.url ?? '';

	const has_photo = (a.image != '' && a.image != null) ? true : false;
	const has_video = (a.video != '' && a.video != null) ? true : false;
	const has_media = (has_photo || has_video) ? true : false;

	let icon = '';
	switch(a.config.type) {
		case 'closed_text':
			icon = 'knk-button';
			break;
		case 'open_text':
			icon = 'knk-open-text';
			break;
		case 'list':
			icon = 'knk-options-list';
			break;
		case 'rating':
			icon = 'knk-rating';
			break;
		case 'Facebook':
			icon = 'ep-facebook';
			break;
		case 'Twitter':
			icon = 'ep-twitter';
			break;
	}

	const answer_validation_types = [
		{ k:'none', v:"No Validation" },
		{ k:'numeric', v:"By numbers" },
		{ k:'regexp', v:"By a regular expression" },
		{ k:'email', v:"By an email" },
	];

	const answer_list_type = [
		{ k:'list', v:"Drop-down list" },
		{ k:'autocomplete', v:"Autocomplete list" },
		{ k:'radios', v:"Radiobutton list" },
	];

	const answer_correct_validations = [
		{ k:'-', v:"No"},
		{ k:'list', v:"By a list" },
		{ k:'regexp', v:"By a regular expression" },
	];
	
	let disable_hide_text_status = false;
	let disable_hide_text_msg = "";
	if(!has_photo && a.config.type == 'closed_text') {
		disable_hide_text_status = true;
		disable_hide_text_msg = "Only available when image is added";
	}
	if(a.config.type == 'rating') {
		disable_hide_text_status = false;
		disable_hide_text_msg = "";
	}

	const display_score_input = (a.config.correct_validation != '-' && (a.config.type != 'rating' && (a.config.scorepoints == undefined || !a.config.scorepoints))) ? true : false;

	const li_classes = ['gui_sortable_list_item', 'gui_flexbox', 'gui_flex_start', 'gui_flex_col', 'gui_flex_nowrap', 'gui_flex_align_center', `${a.config.type}_type`];

	return (
		<li class={li_classes.join(" ")}>
			<div class={`item_header${(open) ? ' is_open' : ''}`}>
				<DragHandle />

				<div class="item_title_container">
					<div>
						<ActionLink
							onClick={() => actions.edit(a)}
							_class={{ icon, other:'item_title' }}
							autotranslate={false}
						><strong>{((open) ? label : a.answer_st)}</strong></ActionLink>
					</div>
				</div>

				<ButtonCollection>
					{(!open && display_score_input) && (
						<div class="gui_input_in_list">
							<Model
								model={a}
								change={props.changeAnswer}
							>
								<Input
									name="correct"
									min={0}
									value={a.correct}
									_type="number"
									_class={{ first:true }}
								/>
							</Model>
						</div>
					)}

					<ToggleButton
						squared={true}
						icon='knk-hide'
						icon_off='knk-edit'
						active={((open) ? true : false)}
						onClick={() => actions.edit(a)}
						aria-label="Edit"
					/>

					<SquaredButtonWithHoverActivation
						squared={true}
						icon='knk-copy'
						onClick={() => actions.copy(a)}
						onKeyMouse={(e) => keyMouse(e, a)}
						onMousePaste={(type, text) => mousePaste(type, text, a)}
						aria-label="Copy"
					/>

					<DeleteButton
						squared={true}
						_position="left"
						onClick={() => actions.delete(a)}
						aria-label="Delete"
					/>
				</ButtonCollection>
			</div>

			{(open) && (
				<div class="gui_item_unfoldable_options">
					<Model
						model={a}
						change={props.changeAnswer}
					>
						<RichEditor
							name="answer"
							tools={['strong', 'em']}
							has_emojis={true}
						>Answer text</RichEditor>

						<MediaUploader
							auto_url={`/quizs/auto_img/${a.promotion_id}`}
							auto_type={'answer'}
							imageField="image"
							videoField="video"
							hooks={props.image_hook}
							image={a.fullimage}
							video={video_url}
							_size={{ fit:500 }}
						>Upload media</MediaUploader>

						{(has_media) && (
							<MatrixSelector
								name="isVertical"
								value={(a.isVertical) ? 'single' : 'double'}
								allow='photo_orientation'
								_default_value='single'
							>Position</MatrixSelector>
						)}
					</Model>

					<DisabledArea
						disabled={disable_hide_text_status}
						message={disable_hide_text_msg}
					>
						<Model
							model={a}
							change={props.changeAnswer}
						>
							<Checkbox
								name="config.hidetext"
							>Hide Answer text</Checkbox>
						</Model>
					</DisabledArea>

					{(a.config.type == 'open_text') && (
						<Model
							model={a}
							change={props.changeAnswer}
						>
							<Checkbox
								name="config.text_size"
							>Long text</Checkbox>

							<Checkbox
								name="config.optional"
							>Make this answer optional</Checkbox>

							<Input
								name="config.max_length"
								errors={(a.config.max_length != undefined && isNaN(a.config.max_length)) ? { 'config.max_length':'This field must be numeric' } : null}
								value={a.config.max_length}
								_class={{ size:30 }}
							>Maximum characters allowed to answer</Input>

							<Select
								name="config.validation"
								values={answer_validation_types}
							>Method of validation</Select>

							{(a.config.validation == 'regexp') && (
								<Input
									name="config.regexp"
									value={a.config.regexp}
								>Validation regexp</Input>
							)}
						</Model>
					)}

					{(a.config.type == 'list') && (
						<Model
							model={a}
							change={props.changeAnswer}
						>
							<Select
								name="config.list_type"
								values={answer_list_type}
							>Type of list</Select>

							<TextArea
								name="config.values"
								value={config_values}
							>Options</TextArea>

							{(a.config.list_type == 'list') && (
								<Checkbox
									name="config.first_empty"
									value={a.config?.first_empty ?? '0'}
								>Add blank option to the top of the list</Checkbox>
							)}
						</Model>
					)}

					{(a.config.type == 'rating') && (
						<Model
							model={a}
							change={props.changeAnswer}
						>
							<Range
								min={2}
								max={10}
								name="config.star_count"
								value={a.config.star_count}
								default={3}
								step={1}
								_class={{ size:50, first:true }}
							>Number of rating icons</Range>

							<Range
								min={1}
								max={a.config.star_count}
								name="config.default_rate"
								value={a.config.default_rate}
								default={3}
								step={1}
								_class={{ size:50, first:true }}
							>Default rate</Range>

							<MatrixSelector
								name="config.img_on"
								value={a.config.img_on.replace("raty_icon ", "")}
								allow='rating_single_type'
								_default_value='ep-star'
								_class={{ size:60 }}
							>Rating icon</MatrixSelector>
						</Model>
					)}

					{(question.multiorder) && (
						<Model
							model={a}
							change={props.changeAnswer}
						>
							<Input
								name="config.correct_values"
								label_props={{
									tooltip:<Tooltip>In case of a correct/incorrect question type, write here the correct answer.</Tooltip>,
								}}
								value={a.config.correct_values}
								_class={{ size:30 }}
							>Correct position</Input>
						</Model>
					)}

					{(!['closed_text', 'rating'].includes(a.config.type)) && (
						<Model
							model={a}
							change={props.changeAnswer}
						>
							{(a.config.type != 'image') && (
								<Select
									name="config.correct_validation"
									values={answer_correct_validations}
								>Assign right answer</Select>
							)}

							{((a.config?.correct_validation ?? 'list') == 'list') && (
								<TextArea
									name="config.correct_values"
									value={correct_values}
									label_props={{
										tooltip:<Tooltip>In case of a correct/incorrect question type, here the correct answers.</Tooltip>,
									}}
								>Correct answers</TextArea>
							)}

							{(a.config.correct_validation == 'regexp') && (
								<Input
									name="config.correct_regexp"
									value={a.config.correct_regexp}
									label_props={{
										tooltip:<Tooltip>In case of a correct/incorrect question type, here the correct answers.</Tooltip>,
									}}
								>RegExp</Input>
							)}
						</Model>
					)}

					{(display_score_input) && (
						<Model
							model={a}
							change={props.changeAnswer}
						>
							<Input
								name="correct"
								min={0}
								label_props={{
									tooltip:<Tooltip position="top">In case of a correct/incorrect question type, enter an amount of points if the answer is correct (for example, 1), or leave it at 0 if it is incorrect.</Tooltip>,
								}}
								value={a.config.correct}
								_type="number"
								_class={{ size:30 }}
							>Number of points</Input>
						</Model>
					)}
				</div>
			)}
		</li>
	);
};

export default injectIntl(AnswerOptions);